import formInputCommonOptions from '../../foundation/js/utils/forms/formInputCommonOptions.js'

const options = formInputCommonOptions('FormInputGeneric', {
    validatorFunction(input) {
        return !!(input.length > 1)
    },

    onInputChange(value) {
        console.log('Special logic just for this input:', value)
    },
})

export default options
